import React, { useState, useEffect } from "react";
import axios from "axios";
import Instagram from "./Instagram";
import ApiService from "../../api/ApiService"


const InstagramSection = () => {
  const [instadata, setInstadata] = useState([]);
  const [profileLogoinsta, setProfileLogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  
     useEffect(() => {
    const fetchInstagramData = async () => {
      try {
        setLoading(true);
        
       const apidata = await ApiService.fetchInstagramData();
        setInstadata(apidata?.data || []);
        setProfileLogo(apidata?.ProfileLogo || null);
      } catch (error) {
         console.error("❌ Error fetching Instagram data:", error);
        setError("Failed to load Instagram content");
      } finally {
        setLoading(false);
      }
    };

    fetchInstagramData();
  }, []);

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Loading Instagram content...</span>
        </div>
        <p className="mt-3">Loading Instagram posts...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-warning" role="alert">
          <h4>Instagram Content Unavailable</h4>
          <p>We're having trouble loading Instagram posts right now. Please try again later.</p>
          <button 
            className="btn btn-warning text-white"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <Instagram 
      logo={profileLogoinsta} 
      instadata={instadata} 
    />
  );
};

export default InstagramSection;